import { z } from "zod";
import { pulseSurveyStatusSchema } from "@/features/pulse-surveys/schemas/pulse-survey.schema";

/// URL-state for the survey list filters (S3, filters live in the URL,
/// so refresh + share + back-button all work).
/// "ai-pulse" is the legacy value for the automatic-survey tab (renamed to
/// "pulse"); it stays in the enum so old bookmarks keep working and is
/// normalized to "pulse" by `resolveListTab`.
export const pulseSurveysListSearchSchema = z
  .object({
    status: pulseSurveyStatusSchema.optional(),
    /// Active tab. Default "surveys" is applied in the route component (not
    /// here) so plain /pulse-surveys URLs stay clean.
    tab: z.enum(["surveys", "pulse", "ai-pulse"]).optional(),
  })
  .strict();

export type PulseSurveysListSearch = z.infer<typeof pulseSurveysListSearchSchema>;

export type PulseSurveysListTab = "surveys" | "pulse";

export function resolveListTab(tab: PulseSurveysListSearch["tab"]): PulseSurveysListTab {
  return tab === "pulse" || tab === "ai-pulse" ? "pulse" : "surveys";
}
